// src/components/common/SaveStatusIndicator.jsx
// Shared save-status pill (dot + label) used anywhere an autosave hook's
// `saveStatus` needs to be surfaced to the user. Mirrors the color/text
// semantics established in BookCoverDesigner's Progress panel.
import React from 'react';
import { Box } from '@mui/material';

export const SAVE_STATUS_CONFIG = {
  saved:   { text: '✓ Saved',              color: '#10b981' },
  saving:  { text: '⏳ Saving...',          color: '#f59e0b' },
  unsaved: { text: '● Unsaved changes',    color: '#ef4444' },
  error:   { text: '⚠ Save failed — click to retry', color: '#dc2626' },
};

export default function SaveStatusIndicator({ status, onRetry, sx }) {
  const info = SAVE_STATUS_CONFIG[status] || SAVE_STATUS_CONFIG.saved;
  const clickable = status === 'error' && typeof onRetry === 'function';

  return (
    <Box
      onClick={clickable ? onRetry : undefined}
      role={clickable ? 'button' : undefined}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        cursor: clickable ? 'pointer' : 'default',
        ...sx,
      }}
    >
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: info.color,
          flexShrink: 0,
        }}
      />
      <Box
        component="span"
        sx={{ fontSize: '12.5px', fontWeight: 600, letterSpacing: '0.2px', color: info.color }}
      >
        {info.text}
      </Box>
    </Box>
  );
}
